import { ApisInfo } from '@/types';
import { createActionCreator } from 'deox';

export const fetchApisInfoActions = {
  request: createActionCreator('FETCH_APIS_INFO_REQUEST', (resolve) => (entityId: string) => resolve({ entityId })),
  success: createActionCreator('FETCH_APIS_INFO_SUCCESS', (resolve) => (groups: string[], apis: ApisInfo) =>
    resolve({ groups, apis })
  ),
  failure: createActionCreator('FETCH_APIS_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
  reset: createActionCreator('FETCH_APIS_INFO_RESET'),
};
